import { ActionSubTypes } from '../../../../actions/ActionSubTypes';
import ApiBaseReducer from '../../../core/ApiBaseReducer';
import pList from '../../../../api/models/pList';
import { rOyakProjeToplamHakedis } from '../../../../api/models/.catalog';
import { DefaultInputDataStateModel, IInputDataStateModel } from '../../../../models/StateModels';

export default ApiBaseReducer<
  pList,
  IInputDataStateModel<pList, rOyakProjeToplamHakedis>,
  rOyakProjeToplamHakedis
>(
  ActionSubTypes.API_OYAKPROJETOPLAMHAKEDISLISTE,
  DefaultInputDataStateModel<pList, rOyakProjeToplamHakedis>()
);
